import React from 'react';
import './ServiceDetail.css';
import SubpagesLink from './SubpagesLink';
import TestimonialSection from './TestimonialSection';
import serviceImage from '../assets/service1.png';
import ndisLogo from '../assets/ramp-icon-update.png';
import SkewedContainer from 'sc-react';
import { Helmet } from 'react-helmet';
import SignupForm from './utils/SignupForm';
import { Link } from 'react-router-dom';
import HealthSection from './utils/HealthSection';

const Understandingdifferenttrainingtechniquessupersetsdropsetsandmore = () => {
    return (
        <div>
            <div className="service-detail-content">
                <div className="service-detail-text">
                    <br></br><br></br>
                    <h1>Maximize Your Training with Advanced Techniques</h1>
                    <h2>Explore the world of advanced training techniques like Supersets, Drop Sets, and more at Ramp Physio and Fitness to enhance your fitness journey in Homebush, NSW.</h2>
                    <p>Are you ready to take your workouts to the next level? At Ramp Physio and Fitness, we are committed to helping you achieve your health and fitness goals through expert guidance and advanced training techniques. This article will provide an in-depth understanding of various training methods such as Supersets, Drop Sets, and others, explaining how they can turbocharge your routine and help you achieve hypertrophy, endurance, and strength gains.</p>
                    <a href="https://docs.google.com/forms/d/e/1FAIpQLSf-SNK-w_xwsp3QPzQGLmvpbNB_dmG5Khx6kfXMejLNMmJoYg/viewform?pli=1"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="servicedetail-book-now"
                        onClick={() => {
                          window.gtag_report_conversion('https://docs.google.com/forms/d/e/1FAIpQLSf-SNK-w_xwsp3QPzQGLmvpbNB_dmG5Khx6kfXMejLNMmJoYg/viewform?pli=1');
                        }}>
                        Book Now
                    </a>
                </div>
                <div className="service-detail-image-container">
                    <img src={serviceImage} alt="Service Detail" className="service-detail-image" />
                </div>
            </div>
            <SkewedContainer top="left" bottom="left" bgColor="white" noMargin>
                <div className="service-intro-container1">
                    <div className="service-intro-content1">
                        <h1>Superset Your Way to Success</h1>
                        <p>Supersets involve performing two exercises back-to-back with no rest in between. This technique can significantly increase the intensity of your workout, reduce your gym time, and promote muscular endurance and hypertrophy. Whether you're pairing antagonist muscle groups or targeting the same muscle with different exercises, supersets can be a game-changer in your training regimen.</p>
                    </div>
                    <div className="intro-image">
                        <img src="../assets/bike.webp" alt="Exercise" />
                    </div>
                </div>
            </SkewedContainer>
            <div className="service-intro-container2">
                <div className="intro-image">
                    <img src="../assets/massage.webp" alt="Exercise" />
                </div>
                <div className="service-intro-content2">
                    <h1>Drop Sets for Muscle Growth</h1>
                    <p>Drop sets are a powerful technique to push beyond muscle failure by dropping the weight and continuing to perform reps until failure is reached again. This method can lead to increased muscle size and endurance by thoroughly exhausting the muscle fibers. Drop sets are particularly effective for breaking through plateaus and stimulating muscle growth.</p>
                </div>
            </div>
            <SkewedContainer bottom="left" bgColor="white" noMargin>
                <div className="service-intro-container3">
                    <img src={ndisLogo} alt="NDIS Logo" className="service-intro-logo" />
                    <p className="service-intro-text">
                        Ramp Physio and Fitness
                    </p>
                    <a href="https://docs.google.com/forms/d/e/1FAIpQLSf-SNK-w_xwsp3QPzQGLmvpbNB_dmG5Khx6kfXMejLNMmJoYg/viewform?pli=1"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="servicedetail-book-now"
                        onClick={() => {
                          window.gtag_report_conversion('https://docs.google.com/forms/d/e/1FAIpQLSf-SNK-w_xwsp3QPzQGLmvpbNB_dmG5Khx6kfXMejLNMmJoYg/viewform?pli=1');
                        }}>
                        Book Now
                    </a>
                </div>
            </SkewedContainer>
            
            <div className="service-intro-container4">
                <div className="service-intro-content4">
                    <h1>Understanding Giant Sets</h1>
                    <p>Giant sets involve performing four or more exercises consecutively with minimal rest in between. This advanced technique is excellent for increasing workout density, challenging cardiovascular capacity, and inducing muscle hypertrophy. Giant sets can target one muscle group or several, making them versatile and effective for all-around fitness.</p>
                </div>
                <div className="intro-image">
                    <img src="../assets/bike.webp" alt="Exercise" />
                </div>
            </div>
            <SkewedContainer top="left" bgColor="#2980b9" noMargin>
            <div className="service-intro-container2">
                <div className="intro-image">
                    <img src="../assets/Gymfloor1.webp" alt="Exercise" />
                </div>
                <div className="service-intro-content2">
                    <h1>Advanced Techniques for Hypertrophy</h1>
                    <p>Advanced training techniques, when applied correctly, can significantly affect hypertrophy, or muscle growth. These methods increase training volume and intensity, leading to greater muscle fatigue and subsequent growth during recovery. Techniques like supersets, drop sets, and giant sets are all effective ways to stimulate hypertrophy in different muscle fibers, contributing to a well-rounded physique.</p>
                    <br></br>
                    <p>
                        To conclude, incorporating advanced training techniques such as Supersets, Drop Sets, and Giant Sets into your workout routine can lead to impressive gains in strength, endurance, and muscle size. At Ramp Physio and Fitness, we are dedicated to helping you understand and implement these methods to achieve your fitness aspirations. Join us for a session, and let's work together to elevate your training experience.
                    </p>
                </div>
            </div>
            </SkewedContainer>
            
    <SubpagesLink />
    <HealthSection />
            <TestimonialSection />
        </div>
    );
};

export default Understandingdifferenttrainingtechniquessupersetsdropsetsandmore;